import React, { useEffect, useState } from 'react';
import NavMenu from '../section/LoggedInNav.js';
import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';
import { setAuthToken } from '../axios.js';
import { useAuthenticator } from '@aws-amplify/ui-react';


//boostrap components 
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

//pages 

import { Authenticator } from '@aws-amplify/ui-react';
import { Switch, Link, useRouteMatch, Route } from 'react-router-dom';
//user or admin settings below

import { UserPage } from './UserPage.js';
import { AdminPage } from './AdminPage.js';
import { findAccountByEmail } from './Register.js';

import AdditionalHelp from '../section/AdditionalHelp.js';


const maskTaxId = (taxId) => {
  const digits = `${taxId || ''}`.replace(/\D/g, '');
  const lastFour = digits.slice(-4);

  if (!lastFour) {
    return '***-**-****';
  }

  return `***-**-${lastFour.padStart(4, '*')}`;
};

const supportEmail = 'portalhelp@metrohousingboston.org';


const SupportEmailButton = ({
  buttonText,
  modalTitle,
  modalMessage,
  emailSubject,
  className = '',
  variant = 'primary',
}) => {
  const [showModal, setShowModal] = useState(false);
  const [copyStatus, setCopyStatus] = useState('');

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(supportEmail);
      setCopyStatus('Email copied to clipboard.');
    } catch (error) {
      setCopyStatus(`Please copy this email manually: ${supportEmail}`);
    }
  };

  return (
    <>
      <Button
        variant={variant}
        className={className}
        onClick={() => {
          setCopyStatus('');
          setShowModal(true);
        }}
      >
        {buttonText}
      </Button>

      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setCopyStatus('');
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{modalMessage}</p>
          <p><strong>{supportEmail}</strong></p>
          {emailSubject && (
            <p>
              Suggested subject: <strong>{emailSubject}</strong>
            </p>
          )}
          {copyStatus && <p className='mb-0'>{copyStatus}</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant='primary' onClick={handleCopyEmail}>
            Copy email
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const UserSettingsContent = ({ user, path, url, groups, isAdmin }) => {
  const [userProperties, setUserProperties] = useState([]);
  const [isLoadingProperties, setIsLoadingProperties] = useState(true);
  const [propertyError, setPropertyError] = useState('');
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showPropertyModal, setShowPropertyModal] = useState(false);

  const propertyDetails = selectedProperty ? [
    { label: 'U_PROPERTY_TAXID', value: selectedProperty.U_PROPERTY_TAXID },
    { label: 'PROPERTY_NAME', value: selectedProperty.PROPERTY_NAME },
    { label: 'PROPERTY_ADDRESS', value: selectedProperty.PROPERTY_ADDRESS },
    { label: 'PROPERTY_PHONENUMBER', value: selectedProperty.PROPERTY_PHONENUMBER },
    { label: 'PROPERTY_EMAILADDRESS', value: selectedProperty.PROPERTY_EMAILADDRESS },
    { label: 'PROPERTYOWNR_FIRSTNAME_', value: selectedProperty.PROPERTYOWNR_FIRSTNAME_ },
    { label: 'PROPERTYOWNR_LASTNAME', value: selectedProperty.PROPERTYOWNR_LASTNAME },
  ] : [];

  useEffect(() => {
    let isMounted = true;

    const fetchUserProperties = async () => {
      try {
        setIsLoadingProperties(true);
        setPropertyError('');

        const response = await findAccountByEmail(user?.attributes?.email?.toLowerCase());

        if (!isMounted) {
          return;
        }

        if (response?.rows) {
          setUserProperties(response.rows);
          return;
        }

        setUserProperties([]);
        setPropertyError('Unable to load properties for this account.');
      } catch (error) {
        if (!isMounted) {
          return;
        }

        setUserProperties([]);
        setPropertyError('Unable to load properties for this account.');
      } finally {
        if (isMounted) {
          setIsLoadingProperties(false);
        }
      }
    };

    fetchUserProperties();

    return () => {
      isMounted = false;
    };
  }, [user]);

  return (
    <div className='App '>
      <h3 className='text-center emphTitle'>User Data</h3>
      <hr></hr>
      <div className=''>
        <p>User Name: {user.username}</p>
        <br></br>
        <p>First Name: {user.attributes.given_name}</p>
        <br></br>
        <p>Last Name: {user.attributes.family_name}</p>
        <br></br>
        <p>Email Adress: {user.attributes.email}</p>
        <br></br>
      </div>
      <div className=''>
        <h3 className='text-center emphTitle'>My Properties</h3>
        <div className='table-responsive'>
          <Table striped bordered hover responsive className='mt-3'>
            <thead>
              <tr>
                <th>Property TAXID</th>
                <th>Property Name</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {isLoadingProperties ? (
                <tr>
                  <td colSpan={3}>Loading properties...</td>
                </tr>
              ) : propertyError ? (
                <tr>
                  <td colSpan={3}>{propertyError}</td>
                </tr>
              ) : userProperties.length === 0 ? (
                <tr>
                  <td colSpan={3}>No properties found for this account.</td>
                </tr>
              ) : (
                userProperties.map((property, index) => (
                  <tr key={property.U_PROPERTY_TAXID || `${property.PROPERTY_NAME}-${index}`}>
                    <td>{maskTaxId(property.U_PROPERTY_TAXID)}</td>
                    <td>{property.PROPERTY_NAME || 'N/A'}</td>
                    <td>
                      <Button
                        variant='outline-primary'
                        size='sm'
                        onClick={() => {
                          setSelectedProperty(property);
                          setShowPropertyModal(true);
                        }}
                      >
                        View Details
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
        <Modal
          show={showPropertyModal}
          onHide={() => {
            setShowPropertyModal(false);
            setSelectedProperty(null);
          }}
          centered
          size='lg'
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedProperty?.PROPERTY_NAME || 'Property Details'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Column Name</th>
                    <th>Data</th>
                  </tr>
                </thead>
                <tbody>
                  {propertyDetails.map((detail) => (
                    <tr key={detail.label}>
                      <td>{detail.label}</td>
                      <td>{detail.value || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant='secondary'
              onClick={() => {
                setShowPropertyModal(false);
                setSelectedProperty(null);
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <div className='d-flex justify-content-center mt-3'>
          <SupportEmailButton
            buttonText='Add Missing Property'
            modalTitle='Add Missing Property'
            modalMessage='If one of your properties is missing, please contact Metro Housing Boston at:'
            emailSubject='[Add Missing Property]'
          />
        </div>
      </div>
      <div className='whiteFont remove'>
        <h5>{`Logged In ${
          groups.length > 0 ? groups : 'Account:'
        }`}</h5>
        <ul>
          <li>
            <br></br>
            <Link to={`${url}`}>{user.username}</Link>
          </li>
          {isAdmin && (
            <li>
              <Link to={`${url}/admin`}>Admin</Link>
            </li>
          )}
        </ul>
      </div>
      <hr />
      <Switch>
        <Route path={`${'/main'}`} exact>
          <UserPage />
        </Route>
        <Route path={`${path}/admin`}>
          <AdminPage />
        </Route>
      </Switch>
    </div>
  );
};


export const UserSettings = () => {
  const { path, url } = useRouteMatch();
  const { user } = useAuthenticator((context) => [ context.user ]);

  return (

    <div className='App'>
        <div className='hidden'>
          <Banner/>
        </div>
        <NavMenu/> 

        <Container className='App padding-top'>
          <Row>
            <Col  xs={12} md={12} lg={6} xl={6}>
              <div className='rightContent '> 

                <Authenticator className='login_container container' loginMechanisms={['email']} hideSignUp 
                  components={{
                    SignUp: {
                      FormFields() {
                        return (
                          <>
                            <Authenticator.SignUp.FormFields />
                            {/* Custom fields for given_name and family_name */}
                            <div><label>First name</label></div>
                            <input
                              type='text'
                              name='given_name'
                              placeholder='Please enter your first name'
                            />
                            <div><label>Last name</label></div>
                            <input
                              type='text'
                              name='family_name'
                              placeholder='Please enter your last name'
                            />
                            <div><label>Email</label></div>
                            <input
                              type='text'
                              name='email'
                              placeholder='Please enter a valid email'
                            />


                          </>
                        );
                      },
                    },
                    }}
                  services={{
                    async validateCustomSignUp(formData) {
                      if (!formData.given_name) {
                        return {
                          given_name: 'First Name is required',
                        };
                      }
                      if (!formData.family_name) {
                        return {
                          family_name: 'Last Name is required',
                        };
                      }
                      if (!formData.email) {
                        return {
                          email: 'Email is required',
                        };
                      }
                    },
                    }}
                    >
                  {({ user }) => {
                    const session = user.getSignInUserSession();
                    if (!session) throw new Error('SignInSession is empty!');
                    const accessToken = session.getAccessToken();
                    const idToken = session.getIdToken();
                    setAuthToken(idToken.getJwtToken());
                    const groups = accessToken.payload['cognito:groups'] || [];
                    const isAdmin = groups.includes('admin');
                    return (
                      <UserSettingsContent
                        user={user}
                        path={path}
                        url={url}
                        groups={groups}
                        isAdmin={isAdmin}
                      />
                    );
                  }}
                </Authenticator>
              </div>            
            </Col>
            
            <Col  xs={12} md={12} lg={6} xl={6}>
              <div className='leftContent  '>
                <h4 className='emphTitle text-center'>FAQ</h4>
                <hr></hr>
                <br></br>

                <h4 className='emphTitle text-center'>Unable to View Payments?</h4>
                <p className=' '>Please make sure that you are signed up & logged in using your Metro Housing Boston Affiliated email account. 
                  This is the account you provided to Metro Housing Boston when the application for Rent Relief was filed</p>
                <p className=' '>Please file a request with <SupportEmailButton buttonText='Portal Help / Technical Support' modalTitle='Update portal email' modalMessage='To update your MHB affiliated email account, please contact Metro Housing Boston at:' emailSubject='[Update Portal Email]' className='mx-1' /> to update your MHB affiliated email account</p>
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'>Incorrect data submitted when account was created?</h4>
                <p className=' '>Please file a request with <SupportEmailButton buttonText='Portal Help / Technical Support' modalTitle='Incorrect account data' modalMessage='To request an edit to your account information, please contact Metro Housing Boston at:' emailSubject='[Incorrect Account Data]' className='mx-1' /> to edit your account</p>
                <br></br>
                <hr></hr>

                <h4 className='emphTitle text-center'>Duplicate Payment Data shown on Payments Page?</h4>
                <p className=' '>Please file a request with <SupportEmailButton buttonText='Portal Help / Technical Support' modalTitle='Duplicate payment data' modalMessage='To report invalid payment information, please contact Metro Housing Boston at:' emailSubject='[Duplicate Payment Data]' className='mx-1' /> to edit the invalid payment information</p>
                <br></br>
                <hr></hr>
                
                
              </div>              
            </Col>
          </Row>

        </Container>

        {user && <AdditionalHelp/>}

        <SITELINKS/> 

    </div>
  );
};